import styled, { keyframes } from "styled-components";

const expansion = () => keyframes`
 0% {
  box-shadow: 0 0 0 0px rgba(255,0,0,.5);
 }
 100% {
  box-shadow: 0 0 0 5px rgba(255,0,0,.5);
 }
`;

export const FlorenzFieldForm = styled.div`
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-family: "Nunito Sans";
    font-size: 17px;
    &__icon-payload {
      margin-left: 10px;
      font-size: 14px;
      color: #0c0aa2;
    }
    &__text {
      color: #1f1f52;
      font-family: Nunito Sans;
      font-size: 19px;
      margin-right: 10px;
    }
    &__required {
      width: 7px;
      color: #ff5757;
    }
    &__icon {
      color: #1f1f52;
      font-size: 7px;
    }
  }
`;
